import styles from "./style.module.scss";
import ContentLoad from "../../uikit/ContentLoad";

export const SavedViewsSkeleton = () => {
  return (
    <>
      {[...Array(10)].map((_: any, index: number) => (
        <div className={styles.tableLoading} key={index}>
          <ContentLoad />
        </div>
      ))}
    </>
  );
};
